import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// import * as Plotly from 'plotly.js';
import {Chart} from 'chart.js';
declare var Plotly: any;
import { PricingService } from 'src/app/service/pricing.service';
@Component({
  selector: 'app-mini-pricer-graph',
  templateUrl: './mini-pricer-graph.component.html',
  styleUrls: ['./mini-pricer-graph.component.scss']
})
export class MiniPricerGraphComponent implements OnInit {
  @ViewChild("Graph", { static: true })
  @ViewChild("Chart", { static: true })
  private Graph: ElementRef;

  @Input() title: string;
  @Input() graphColours = ''; // comma separated string
  @Input() xAxisLabel: string;
  @Input() yAxisLabel: string;
  @Input() legend: string // comma separated string

  refId = '58bf0bb84cedfd000136eef5';

  isMobileResolution = false;
  transformedData: any = {};
  chartOptions: any;
  chartLabels: any[] = [];
  chartData: any[] = [];
  chartPlugins = [];

  chartColors = [
    {
      borderColor: '#6159c0',
      backgroundColor: 'rgba(0,0,0,0)',
    },
    {
      borderColor: '#6bc059',
      backgroundColor: 'rgba(0,0,0,0)',
    },
    {
      borderColor: '#0097ce',
      backgroundColor: 'rgba(0,0,0,0)',
    },
  ]

  selectorOptions = {
    buttons: [{
        step: 'week',
        stepmode: 'backward',
        count: 1,
        label: '1w'
    }, {
        step: 'month',
        stepmode: 'backward',
        count: 1,
        label: '1m'
    },
    {
      step: 'month',
      stepmode: 'backward',
      count: 3,
      label: '3m'
    },
    {
      step: 'month',
      stepmode: 'backward',
      count: 6,
      label: '6m'
    },
    {
        step: 'year',
        stepmode: 'backward',
        count: 1,
        label: '1y'
    }],
  };

  selectedRange = '1w';
  startDateISO: string;
  endDateISO: string;


  @HostListener('click', ['$event'])
  onButtonClick(event: Event): void {
    const target = event.target as HTMLElement;

    if (target.parentElement.classList.contains('button') 
        && target.parentElement 
        && target.parentElement.parentElement 
        && target.parentElement.parentElement.classList.contains('rangeselector')) {
      this.selectedRange = target.textContent;
      this.setDateRange();
      this.getHistoricalPrice();
    }
  }

  constructor(private route: ActivatedRoute, private pricingService: PricingService) { }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    // Update isMobileResolution based on window width
    this.isMobileResolution = window.innerWidth <= 400;
  }

  ngOnInit() {    
    this.route.queryParams.subscribe(params => {
      const {
        // widgetState: widgetStateParams,
        refId: paramRefId,
        primaryColour,
        secondaryColor,
        title,
        graphColours,
        xAxisLabel,
        yAxisLabel,
        legend,
      } = params;

      this.title = title;
      this.refId = paramRefId;
      this.graphColours = graphColours;
      this.xAxisLabel = xAxisLabel;
      this.yAxisLabel = yAxisLabel;
      this.legend = legend;
      this.setDateRange();
      this.getHistoricalPrice();
      this.getPriceDifference();
    });
  }

  setDateRange() {
    let startDate: Date;
    const now = new Date();
    // End date as today at 12:00 AM
    const endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    this.endDateISO = endDate.toISOString();
    
    switch (this.selectedRange) {
      case '1w': // 1 Week
        startDate = new Date(endDate);
        startDate.setDate(endDate.getDate() - 7);
        break;

      case '1m': // 1 Month
        startDate = new Date(endDate);
        startDate.setMonth(endDate.getMonth() - 1);
        break;

      case '3m': // 3 Months
        startDate = new Date(endDate);
        startDate.setMonth(endDate.getMonth() - 3);
        break;

      case '6m': // 6 Months
        startDate = new Date(endDate);
        startDate.setMonth(endDate.getMonth() - 6);
        break;

      case '1y': // 1 Year
        startDate = new Date(endDate);
        startDate.setFullYear(endDate.getFullYear() - 1);
        break;

      default:
        console.error('Invalid date range selected');
        return;
    }
    this.startDateISO = startDate.toISOString();
  }

  getHistoricalPrice() {
    this.pricingService.getHistoricalPrice(this.startDateISO, this.endDateISO).subscribe((res) => {
      console.log('historicalPrice', res);
      this.transformData(res);
    }, err => {
      console.error(err);
    });

    this.pricingService.getSearch('58bf0bb84cedfd000136eee4').subscribe((res) => {
      console.log('getSearch', res);
    }, err => {
      console.error(err);
    });
  }

  getPriceDifference() {
    this.pricingService.getPriceDifference().subscribe((res) => {
      console.log('priceDifference', res);
    }, err => {
      console.error(err);
    });
  }

  transformData(res: string) {
    const colours = this.graphColours.split(',');
    const legends = this.legend.split(',');
    Object.keys(res).forEach((scenario, i) => {
      const data = res[scenario];
      this.transformedData[`trace${i+1}`] = {
        x: data.map(item => item.datetime.split("T")[0]), // Extract date part only
        y: data.map(item => item.rate),
        type: 'scatter',
        mode: 'lines',
        name: legends[i],
        line: {
          color: '#' + colours[i]
        }
      };
    });
    console.log('transformedData', this.transformedData);
    this.createTimeSeriesGraph();
  }

  createTimeSeriesGraph() {
    const data = Object.values(this.transformedData);
    
    const layout = {
      title: this.title,
      xaxis: {
        title: this.xAxisLabel, 
        rangeselector: this.selectorOptions
      },
      yaxis: {
        title: this.yAxisLabel,
      }
    };

    Plotly.newPlot('timeSeriesGraph', data, layout);
  }

}
